import { Injectable, Injector, Inject, PLATFORM_ID } from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import {Observable, throwError} from 'rxjs';
import {AuthService} from './auth.service';
import {catchError, retry, tap} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private inj: Injector,
    @Inject(PLATFORM_ID) private platformId,
    public toastrService: ToastrService
  ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
// Get the auth header from the service.
    const auth = this.inj.get(AuthService);
// Clone the request to add the new header.
    let headers = req.headers;
    if (isPlatformBrowser(this.platformId)) {
      headers = req.headers.set('Authorization', 'Bearer ' + auth.getAccessToken());
    }
    const authReq = req.clone({ headers });
    // Pass on the cloned request instead of the original request.
    return next.handle(authReq).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        if (typeof error.error === 'object') {
          error = error.error;
        }
        if (error.error) {
          if (error.error === 'Unauthorized') {
            this.ShowError('Hết phiên đăng nhập vui lòng đăng nhập lại!');
            location.reload();
          } else {
            this.ShowError(error.error);
          }
        } else if (error.status) {
          this.ShowError(this.GetErrorString(error.status));
        } else {
          this.ShowError('Có lỗi xảy ra!');
        }
        return throwError(error);
      }),
      tap((event: HttpResponse<any>) => {
        // catch errors that come as JSON response from server
        const { body } = event;
        if (body && body.error) {
          this.ShowError(body.error);
          throw new Error(body.error);
        }
      }),
    );
  }
  private ShowError(s) {
    this.toastrService.error(s, 'Lỗi', {
      timeOut: 3000
    });
  }
  private GetErrorString(status) {
    switch (status) {
      case 401:
        return 'Không có quyền thực hiện thao tác, yêu cầu đăng nhập lại!';
        break;
      case 400:
        return 'Yêu cầu không hợp lệ!';
        break;
      default:
        return 'Có lỗi xảy ra!';
        break;
    }
  }
}
